const protocol = process.env.REACT_APP_SFP_API_PROTOCOL || 'http';
const host = process.env.REACT_APP_SFP_API_HOST || 'localhost';
const port = process.env.REACT_APP_SFP_API_PORT;
const version = process.env.REACT_APP_SFP_API_VERSION || 'latest';
const clientId = process.env.REACT_APP_SFP_API_CLIENT_ID;
const clientSecret = process.env.REACT_APP_SFP_API_CLIENT_SECRET;

const baseUrl = `${protocol}://${host}${port ? `:${port}` : ''}`;
const apiBaseUrl = `${baseUrl}/${version}`;
const oauthBaseUrl = `${baseUrl}/oauth/v2`;

export {
    apiBaseUrl,
    clientId,
    clientSecret,
    oauthBaseUrl
};



// WEBPACK FOOTER //
// ./src/service/sfp/config.js